import { Events } from "@Context/common/general/context";
import { useEffect, useState } from "react";

export const useAccountInfoResolved = (isAuthenticated: boolean) => {
  const [isResolved, setIsResolved] = useState(false);

  useEffect(() => {
    const handleAccountInfoUpdated = (data: unknown) => {
      setIsResolved(Boolean(data));
    };

    const handleLogout = () => {
      setIsResolved(false);
    };

    Events.auth.accountInfoUpdated.uniq(handleAccountInfoUpdated);
    Events.auth.logout.uniq(handleLogout);

    return () => {
      Events.auth.accountInfoUpdated.remove(handleAccountInfoUpdated);
      Events.auth.logout.remove(handleLogout);
    };
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      setIsResolved(false);
    }
  }, [isAuthenticated]);

  return isResolved;
};
